export default __webpack_public_path__ + "assets/img/MaterialIcons-Regular.4674f8ded773cb03e824323bfc950537.eot";